import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { routes } from './routes';

@NgModule({
  imports: [
    SharedModule,
    CommonModule,
    RouterModule.forRoot(routes)
  ],
  exports: [
    RouterModule,
  ],
})

export class RoutesModule {
  constructor() {
  }

}

